import jQuery from 'jquery';
import 'select2';

/**
 * ColorThemeController class manages the color theme selection and application.
 * It interacts with the ColorThemeService to get and set the current color theme.
 */
export default class ColorThemeController {
    /**
     * Constructs a new instance of ColorThemeController.
     * @param {Object} $scope - The AngularJS scope.
     * @param {Object} $rootScope - The AngularJS root scope.
     * @param {Object} ColorThemeService - The service responsible for managing color themes.
     * @param {Object} $element - The DOM element this controller is attached to.
     * @param {Object} $timeout - Angular's timeout service.
     */
    constructor($scope, $rootScope, ColorThemeService, $element, $timeout) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.ColorThemeService = ColorThemeService;
        this.$element = $element;
        this.$timeout = $timeout;

        // Initialize the current color theme and available themes from the service
        $scope.currentColorTheme = ColorThemeService.getCurrentColorTheme();
        $scope.colorThemes = ColorThemeService.getColorThemes();
        $scope.showColorThemes = false;

        // Bind methods to the current instance to maintain context
        $scope.onColorThemeChange = this.onColorThemeChange.bind(this);
        $scope.changeStyle = this.changeStyle.bind(this);

        // Initialize select2
        this.$timeout(() => {
            const $colorThemePicker = jQuery('#colorThemePicker');
            $colorThemePicker.select2({ 
                minimumResultsForSearch: Infinity 
            });
            
            // Handle select2 change event
            $colorThemePicker.on('select2:select', (e) => {
                const selectedValue = e.target.value;
                this.$scope.$apply(() => {                    
                    this.onColorThemeChange(selectedValue);
                    this.$scope.showColorThemes = false;
                });
            });
        });
    }

    /**
     * Handles the change of the color theme.
     * @param {string} selectedTheme - The value of the selected color theme.
     */
    onColorThemeChange(selectedTheme) {
        console.log('onColorThemeChange', selectedTheme);
        if (selectedTheme) {            
            this.ColorThemeService.setCurrentColorTheme(selectedTheme);
            this.$scope.currentColorTheme = selectedTheme;
        }
    }

    /**
     * Changes the style of the color theme picker and handles its dropdown behavior.
     * @param {string} elem - The element to apply the style changes to.
     */
    changeStyle(elem) {
        const element = angular.element(elem);
        element.toggleClass('active', true);

        const $colorThemePicker = jQuery('#colorThemePicker');
        
        this.$timeout(() => {
            $colorThemePicker.select2('open');

            $colorThemePicker.on('select2:close', () => {
                this.$scope.$apply(() => {
                    element.toggleClass('active', false);
                    this.$scope.showColorThemes = false;
                });
                
                jQuery('.select2-results, .select2-dropdown, .select2-selection__arrow')
                    .toggleClass('themedColorPickerDropdown', false);
            });

            jQuery('.select2-results, .select2-dropdown, .select2-selection__arrow')
                .toggleClass('themedColorPickerDropdown', true);
        });
    }
}
ColorThemeController.$inject = ['$scope', '$rootScope', 'ColorThemeService', '$element', '$timeout'];

/*export default function registerColorThemeController(assessmentFrontendControllers) {
    assessmentFrontendControllers.controller('ColorThemeController', [
        '$scope', 
        '$rootScope', 
        'ColorThemeService', 
        '$element', 
        '$timeout', 
        ColorThemeController
    ]);
}*/